import {
  DwellMetadata,
  SiteDwellBaseReq,
  SiteDwellOverrideReq,
  SiteDwellResp,
  SiteDwellUpsertManyReq,
  TerminalDwellBaseReq,
  TerminalDwellOverrideReq,
  TerminalDwellResp,
  TerminalDwellUpsertManyReq,
} from '@components/DriverTracking/Dwell/api/schema'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useDwellAPI = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()

  const useDwellMetadata = () => {
    const payload = {}
    return useQuery({
      queryKey: ['terminalDwellMetadata', payload],
      queryFn: () => api.post('logistics/dwell/metadata', payload),
    })
  }

  const useTerminalDwellOverview = () => {
    const payload = {}
    return useQuery({
      queryKey: ['terminalDwellOverview', payload],
      queryFn: () => api.post('logistics/dwell/terminal/overview', payload),
    })
  }

  const useTerminalDwellUpsert = useMutation({
    mutationKey: ['terminalDwellUpsert'],
    mutationFn: (payload) => api.post('logistics/dwell/terminal/upsert_many', payload),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['terminalDwellOverview'],
      })
    },
  })
  const useTerminalDwellOverride = useMutation({
    mutationKey: ['terminalDwellOverride'],
    mutationFn: (payload) => api.post('logistics/dwell/terminal/override', payload),
  })

  const useTerminalDwellDelete = useMutation({
    mutationKey: ['terminalDwellDelete'],
    mutationFn: (payload) => api.post('logistics/dwell/terminal/delete', payload),
  })

  const useSiteDwellOverview = () => {
    const payload = {}
    return useQuery({
      queryKey: ['siteDwellOverview', payload],
      queryFn: () => api.post('logistics/dwell/site/overview', payload),
    })
  }

  const useSiteDwellUpsert = useMutation({
    mutationKey: ['siteDwellUpsert'],
    mutationFn: (payload) => api.post('logistics/dwell/site/upsert_many', payload),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['siteDwellOverview'],
      })
    },
  })
  const useSiteDwellOverride = useMutation({
    mutationKey: ['siteDwellOverride'],
    mutationFn: (payload) => api.post('logistics/dwell/site/override', payload),
  })

  const useSiteDwellDelete = useMutation({
    mutationKey: ['siteDwellDelete'],
    mutationFn: (payload) => api.post('logistics/dwell/site/delete', payload),
  })

  return {
    useDwellMetadata,
    useTerminalDwellOverview,
    useTerminalDwellUpsert,
    useTerminalDwellOverride,
    useTerminalDwellDelete,
    useSiteDwellOverview,
    useSiteDwellUpsert,
    useSiteDwellOverride,
    useSiteDwellDelete,
  }
}
